export const anonymizeEmail = (email: string): string => {
    if (!email) return ''

    const [localPart, domain] = email.split('@')
    if (!domain) return email

    const halfLength = Math.floor(localPart.length / 2)
    const visiblePart = localPart.substring(0, halfLength)
    const hiddenPart = '*'.repeat(localPart.length - halfLength)

    return `${visiblePart}${hiddenPart}@${domain}`
}